import React from 'react';
import './RemixChain.css';

/**
 * RemixChain — Visual breadcrumb trail of the remix history.
 *
 * Props:
 *   chain  — Array of { prompt, imageUrl, styleLabel } in chronological order
 *            (first item = Original, last = current)
 *   onNavigate(index) — called when user clicks a past step to jump back to it
 *   onClear()         — called when the × button is clicked to reset the chain
 */
export default function RemixChain({ chain = [], onNavigate, onClear }) {
  if (!chain || chain.length < 2) return null;

  return (
    <div className="remix-chain" aria-label="Remix journey">
      <span className="remix-chain-label">Journey</span>

      {chain.map((step, i) => {
        const isCurrent = i === chain.length - 1;
        const isOrigin = i === 0;
        const label = isOrigin ? 'Original' : (step.styleLabel || `Remix ${i}`);

        return (
          <div key={i} className="remix-chain-node">
            {i > 0 && <span className="remix-chain-arrow" aria-hidden="true">→</span>}

            <button
              className={`remix-chain-step${isCurrent ? ' current' : ''}`}
              onClick={() => !isCurrent && onNavigate?.(i)}
              title={step.prompt}
              aria-current={isCurrent ? 'step' : undefined}
              aria-label={`${label}: ${step.prompt}`}
            >
              {step.imageUrl ? (
                <img
                  className="remix-chain-thumb"
                  src={step.imageUrl}
                  alt=""
                  onError={(e) => { e.target.style.display = 'none'; }}
                />
              ) : (
                <div className="remix-chain-thumb-placeholder">🎨</div>
              )}
              <div className="remix-chain-info">
                <span className="remix-chain-step-label">{label}</span>
                <span className="remix-chain-step-prompt">
                  {step.prompt?.length > 28 ? step.prompt.slice(0, 28) + '…' : step.prompt}
                </span>
              </div>
            </button>
          </div>
        );
      })}

      <button
        className="remix-chain-clear"
        onClick={onClear}
        title="Clear remix history"
        aria-label="Clear remix journey"
      >
        ×
      </button>
    </div>
  );
}
